import { useState } from "react";
import Image from "next/image";

import capitalize from "lodash/capitalize";

import { useCalendarLink } from "@/components/hooks/useCalendarLink";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const MainCallToAction = ({ industry, backgroundImage = "", city }: { industry: string; backgroundImage?: string; city?: string }) => {
  const [businessName, setBusinessName] = useState("");
  const { calendarLink } = useCalendarLink();

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!businessName.trim()) return;
    window.open(
      `${calendarLink}?business-name=${encodeURIComponent(businessName.trim())}&industry=${encodeURIComponent(capitalize(industry))}`,
      "_blank"
    );
    setBusinessName("");
  };

  return (
    <section className="w-full relative bg-rebolt-800 min-h-[500px] flex flex-col justify-center">
      <div className="absolute inset-0 bg-ash-900/40 blur-xs z-10">
        {backgroundImage && (
          <div className="absolute inset-0 overflow-hidden">
            <Image
              src={backgroundImage}
              alt="Main call to action background image"
              fill
              priority
              sizes="100vw"
              quality={75}
              className="object-cover mix-blend-overlay brightness-[0.85] blur-[2px] object-[center_30%]"
            />
          </div>
        )}
      </div>

      <div className="container mx-auto flex flex-col items-center py-16 px-4 relative z-20">
        <p className="text-white mb-4 font-medium text-2xl">Ready to get started?</p>
        <h2 className="text-3xl lg:text-4xl leading-[1.4]! font-bold text-white text-center mb-10 max-w-2xl">
          Simply enter your business name below
        </h2>

        <form onSubmit={handleSubmit} className="flex gap-4 w-full max-w-xl">
          <Input
            type="text"
            value={businessName}
            onChange={(e) => setBusinessName(e.target.value)}
            placeholder="Your business name"
            className="flex-1 h-12 bg-white/50 rounded-[10px] text-black placeholder:text-black/70 border border-white/30"
          />
          <Button
            size="xl"
            type="submit"
            className="bg-white text-rebolt-800 rounded-[10px] text-base! font-semibold hover:bg-ash-200 transition-colors"
          >
            Create my website
          </Button>
        </form>
      </div>
    </section>
  );
};

export default MainCallToAction;
